(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["26fw-grobalcampaign-btsv"] && !Shopify.designMode) return;
  try {
    

document.querySelectorAll('.btsv-marquee__track').forEach(track => {
  const isReverse = track.classList.contains('btsv-marquee__track--right');
  const speed = 0.5;
  let pos = isReverse ? -track.scrollWidth / 2 : 0;
  let isDragging = false;
  let dragStartX = 0;
  let dragStartPos = 0;

  track.style.animation = 'none';
  track.style.transform = `translateX(${pos}px)`;

  function tick() {
    if (!isDragging) {
      pos += isReverse ? speed : -speed;
      const half = track.scrollWidth / 2;
      if (pos < -half) pos += half;
      if (pos > 0) pos -= half;
      track.style.transform = `translateX(${pos}px)`;
    }
    requestAnimationFrame(tick);
  }
  tick();

  // PC マウス
  track.style.cursor = 'grab';

  track.addEventListener('mousedown', e => {
    isDragging = true;
    dragStartX = e.clientX;
    dragStartPos = pos;
    track.style.cursor = 'grabbing';
    e.preventDefault();
  });
  window.addEventListener('mousemove', e => {
    if (!isDragging) return;
    pos = dragStartPos + (e.clientX - dragStartX);
    track.style.transform = `translateX(${pos}px)`;
  });
  window.addEventListener('mouseup', () => {
    if (!isDragging) return;
    isDragging = false;
    track.style.cursor = 'grab';
  });

  // SP タッチ
  track.addEventListener('touchstart', e => {
    isDragging = true;
    dragStartX = e.touches[0].clientX;
    dragStartPos = pos;
  }, { passive: true });

  track.addEventListener('touchmove', e => {
    if (!isDragging) return;
    pos = dragStartPos + (e.touches[0].clientX - dragStartX);
    track.style.transform = `translateX(${pos}px)`;
  }, { passive: true });

  track.addEventListener('touchend', () => {
    isDragging = false;
    // 離した位置からそのまま自動再生継続
  });
});




  } catch(e) { console.error(e); }
})();
})();
